import React, { useState, useEffect, useMemo } from 'react';
import { accessibleOnClick } from '../../../../../../../../shared/utils/accessible-on-click';
import hasPermission from '../../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../../shared/utils/access-control/enums/permissions';

interface PhoneNumberSettingsSideBarProps {
  scrollIntoView: (sectionId: string) => void;
  activeSidebarLabel?: string;
}

const PhoneNumberSettingsSideBar: React.FC<PhoneNumberSettingsSideBarProps> = ({
  scrollIntoView,
  activeSidebarLabel = 'Phone Number Label',
}) => {
  const allSidebarItems = [
    {
      label: 'Phone Number Label',
      id: 'phone-number-label',
    },
    {
      label: 'Assign Number',
      id: 'assign-number',
      permission: Permissions.PHONE_NUMBER_ASSIGNMENT_UPDATE,
    },
    {
      label: 'Call Forwarding',
      id: 'call-forwarding',
    },
    {
      label: 'Call Recording',
      id: 'call-recording',
    },
    {
      label: 'Voicemail Greeting',
      id: 'voicemail-greeting',
    },
  ];

  const sidebarItems = useMemo(
    () =>
      allSidebarItems.filter(
        (item) => !item.permission || hasPermission(item.permission),
      ),
    [],
  );

  //* State
  const [activeLabel, setActiveLabel] = useState<string>('Phone Number Label');

  //* Function
  const handleActiveLabel = (label: string, id: string) => {
    setActiveLabel(label);
    scrollIntoView(id);
  };

  //* useEffect
  useEffect(() => {
    setActiveLabel(activeSidebarLabel);
  }, [activeSidebarLabel]);

  return (
    <div className="phone-number-settings-sidebar">
      {sidebarItems.map(({ label, id }) => (
        <div
          key={id}
          role="button"
          className={`phone-number-settings-sidebar__item ${
            activeLabel === label && 'active'
          }`}
          {...accessibleOnClick(() => handleActiveLabel(label, id))}
        >
          <span
            className={`regular-1 font-medium ${
              activeLabel === label ? 'semibold-1 blue-txt-11' : 'gray-txt-15'
            }`}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PhoneNumberSettingsSideBar;